import { createFileRoute } from "@tanstack/react-router"
import { CategoriesTab } from "./_categories-tab"

export const Route = createFileRoute("/settings/categories")({
  component: CategoriesTab,
})
